module.exports = "/static/img/php.svg?0da6e05d0dc799c7a21e7beb732b58fa";